import { defaultValues } from '@/interfaces/schemas/ticketListFilter.schema'
import { CircularProgress, Container, FormControl, IconButton, InputLabel, ListSubheader, MenuItem, Paper, Select, TextField } from '@mui/material'
import Grid from "@mui/material/Grid2"
import { Box, Button, Divider, Typography } from '@utilisourcepackagelibdev/utilisourcepackagelib'
import { Plus, X } from 'lucide-react'
import React, { useCallback, useEffect } from 'react'
import { Controller, useFieldArray, useFormContext, useWatch } from 'react-hook-form'
import { CFTypeIdDetail } from '../workflowRules/useWorkflowRulesAdminTable.hook'
import { Equality, EqualityDisplayValue, EqualityDisplayValueArray, EqualityNumber, IcfTDateCasesArray, IcfTDropdownCasesArray, IcfTIntegerCasesArray, IcfTStringCasesArray, IcfTToggleCasesArray, turnEqualityValueToDisplayValue, turnEqualityValueToNumber, turnNumberToEqualityValue, turnOldNumberToEqualityValue } from '@/constants/filter/filter.constant'
import CheckboxElement from '@/components/Molecules/Checkbox/CheckboxElement.component'
import { NewCondition, WorkflowRule } from './workflowRules.interface'
import { Condition } from '@/components/Organisms/BasicDrawer/BasicDrawer.component'
// import { Condition, WorkflowRule } from './WorkflowRuleDrawer'
import { createBaseFieldsQueryOptions, createCustomerFieldsQueryOptions } from '@/services/ticket/ticket.options'
import { createTicketTypesByCustomerOptions } from '@/services/ticket/ticketType.options'
import { useQuery } from '@tanstack/react-query'
import { DateRangePicker, DateTimePicker, SingleInputDateRangeField } from '@mui/x-date-pickers-pro'
// import { DateTimeRangePicker } from '@mui/x-date-pickers-pro/DateTimeRangePicker';
import DateRangePro, { shortcutsItems } from "@/components/Organisms/DateRangePro/DateRangePro.component"
import { DatePicker } from '@mui/x-date-pickers-pro'
import dayjs from 'dayjs';
import { Conditions } from './workflowRules.interface'

interface IType {
  name: 'any_conditions' | 'all_conditions',
}

const WorkflowRuleStep2 = () => {

  const methods = useFormContext()
  const { watch, control, setValue } = methods

  const customerWatch = useWatch({ control, name: 'customer' })

  const baseFields = useQuery(createBaseFieldsQueryOptions())
  const ticketTypesByCustomer = useQuery(createTicketTypesByCustomerOptions(customerWatch?.id))
  const customFieldsByCustomer = useQuery(createCustomerFieldsQueryOptions(customerWatch?.id))

  const { fields: allConditionsFields, append: allConditionsAppend, remove: allConditionsRemove, } = useFieldArray({
    control: control,
    name: 'all_conditions',
    shouldUnregister: false
  });

  const { fields: anyConditionsFields, append: anyConditionsAppend, remove: anyConditionsRemove, } = useFieldArray({
    control: control,
    name: 'any_conditions',
    shouldUnregister: false
  });

  const handleAddAnyCondition = () => {
    anyConditionsAppend({
      fieldTypeId: 0,
      conditionId: 0,
      userId: null,
      statusValue: null,
      column: '',
      type: undefined,
      equality: 0,
      equalityDisplay: '',
      fieldId: 0,
      value: '',
      conditionObj: {},

      // condition: '',
      // equality: '',
      // equalityNumber: 0,
      // value: '',
      // conditionObj: {},
      // type: '',
      // allAny: ''
    });
  };

  const handleAddAllCondition = () => {
    allConditionsAppend({
      fieldTypeId: 0,
      conditionId: 0,
      userId: null,
      statusValue: null,
      column: '',
      type: undefined,
      equality: 0,
      equalityDisplay: '',
      fieldId: 0,
      value: '',
      conditionObj: {},

      // condition: '',
      // equality: '',
      // equalityNumber: 0,
      // value: '',
      // conditionObj: {},
      // type: '',
      // allAny: ''
    });
  };

  const handleConditionOnChange = useCallback((item: any, index: number, selectedValue: any, type: IType) => {
    const conditionObject = baseFields?.data.find((item: any) => item.Meta.Name === selectedValue)
      || customFieldsByCustomer?.data.find((item: any) => item.Meta.Name === selectedValue);

    if (conditionObject) {
      const updates = {
        [`${type.name}.${index}.column`]: selectedValue,
        [`${type.name}.${index}.type`]: baseFields?.data.includes(conditionObject) ? "baseField" : "customField",
        [`${type.name}.${index}.conditionObj`]: conditionObject,
        [`${type.name}.${index}.value`]: ""
      };

      Object.entries(updates).forEach(([key, value]) => {
        setValue(key, value, { shouldValidate: true });
      });
    }
  }, [baseFields?.data, customFieldsByCustomer?.data, ticketTypesByCustomer?.data, setValue]);

  const handleEqualityOnChange = (item: any, index: number, selectedValue: string, type: IType) => {
    //? selectedValue is the display Value of the equality
    const equalityNumber = turnEqualityValueToNumber(selectedValue)
    console.log(selectedValue, equalityNumber)
    console.log(EqualityDisplayValueArray[equalityNumber])
    if (equalityNumber === EqualityNumber.isSet || equalityNumber === EqualityNumber.isNotSet || equalityNumber === EqualityNumber.today) {
      setValue(`${type.name}.${index}.value`, "");
    }
    setValue(`${type.name}.${index}.equality`, equalityNumber); // set the number value
    setValue(`${type.name}.${index}.equalityDisplay`, EqualityDisplayValueArray[equalityNumber]); // set the display value
  }

  const ValueController = React.memo(({ condition, index, children, rules, type }: any) => (
    <Controller
      name={`${type.name}.${index}.value`}
      control={control}
      rules={{ required: 'Value is required', ...rules }}
      render={({ field }) => children(field, index)}
    />
  ));


  const renderDropdownType = (condition: any, index: number, type: IType,) => (
    <>
      <ValueController
        type={type}
        condition={condition}
        index={index}
      >
        {(field: any, index: number) => (
          <>
            <InputLabel id="condition">Value</InputLabel>
            <Select
              size="small"
              sx={{ width: '100%' }}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
              {...field}
            >
              {condition?.Type.OptLabels.map((option: any, index: number) => {
                return (
                  <MenuItem
                    key={index}
                    value={option}
                  >
                    {option}
                  </MenuItem>
                )
              })
              }
            </Select>
          </>
        )}
      </ValueController>
    </>

  );

  const renderDateType = (condition: any, index: number, type: IType) => (

    <ValueController
      type={type}
      condition={condition}
      index={index}
    >
      {(field: any, index: number) => {
        const equalityValue = watch(`${type.name}.${index}.equality`);
        const includeTime = condition?.Type?.IncludeTime === true;

        if (equalityValue === EqualityNumber.isBetween) { // is between
          return (
            <Box sx={{ display: 'flex', gap: 2 }}>
              {includeTime ? (
                <DateRangePicker
                  {...field}
                  calendars={2}
                  fullWidth
                  localeText={{ start: 'Start Date', end: 'End Date' }}
                  value={[
                    field.value?.start ? dayjs(field.value.start) : null,
                    field.value?.end ? dayjs(field.value.end) : null
                  ]}
                  onChange={(newValue: any) => {
                    field.onChange({
                      start: newValue[0],
                      end: newValue[1]
                    });
                  }}
                  slotProps={{
                    field: SingleInputDateRangeField,
                    shortcuts: {
                      items: shortcutsItems,
                    },
                    actionBar: {
                      actions: ['clear'],
                    },
                    textField: {
                      fullWidth: true,
                      sx: { width: '100%' },
                      size: 'small'
                    }
                    // toolbar: {
                    //     toolbarFormat: 'YYYY',
                    //     toolbarPlaceholder: '??',
                    // },
                    // calendarHeader: { sx: { border: '1px red solid' } }
                  }}
                  sx={{ width: '100%', mt: 0 }}

                // value={dateRangeOnChange}
                // onChange={setDateRangeOnChange}
                />
              ) : (
                <>
                  <DatePicker
                    {...field}
                    label="Start Date"
                    value={field.value?.start ? dayjs(field.value.start) : null}
                    onChange={(newValue) => {
                      field.onChange({
                        ...field.value,
                        start: newValue
                      });
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: 'small'
                      }
                    }}
                  />
                  <DatePicker
                    {...field}
                    label="End Date"
                    value={field.value?.end ? dayjs(field.value.end) : null}
                    onChange={(newValue) => {
                      field.onChange({
                        ...field.value,
                        end: newValue
                      });
                    }}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: 'small'
                      }
                    }}
                  />
                </>
              )}
            </Box>
          );
        } else {
          return includeTime ? (
            <DateTimePicker
              {...field}
              label={condition?.Meta.Name}
              value={field.value ? dayjs(field.value) : null}
              onChange={(newValue) => field.onChange(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                }
              }}
            />
          ) : (
            <DatePicker
              {...field}
              label={condition?.Meta.Name}
              value={field.value ? dayjs(field.value) : null}
              onChange={(newValue) => field.onChange(newValue)}
              slotProps={{
                textField: {
                  fullWidth: true,
                  size: 'small',
                }
              }}
            />
          );
        }
      }}
    </ValueController>
  );

  const renderStringType = (condition: any, index: number, type: IType) => (
    <ValueController
      type={type}
      condition={condition}
      index={index}
    >
      {(field: any, index: number) => (
        <>
          <InputLabel id="value">Value</InputLabel>
          <TextField placeholder="Type a Value" size="small" sx={{ width: '100%' }} {...field}></TextField>
        </>
      )}
    </ValueController>
  )

  const renderIntegerType = (condition: any, index: number, type: IType) => {


    // <ValueController
    //   type={type}
    //   condition={condition}
    //   index={index}
    // >
    //   {(field: any, index: number) => {
    const equalityValue = watch(`${type.name}.${index}.equality`);

    if (equalityValue === EqualityNumber.isBetween) { // is between
      return (

        <>
          <InputLabel id="value">Value Range</InputLabel>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Controller
              name={`${type.name}.${index}.value[0]`}
              control={control}
              rules={{ required: 'Value is required' }}
              render={({ field }) => (
                <TextField
                  type="number"
                  placeholder="Min Value"
                  size="small"
                  sx={{ width: '100%' }}
                  max={condition?.Type.Maximum}
                  min={condition?.Type.Minimum}
                  step={condition?.Type.Step}
                  {...field}
                />
              )}
            />
            <Typography variant="body2">-</Typography>
            <Controller
              name={`${type.name}.${index}.value[1]`}
              control={control}
              rules={{ required: 'Value is required' }}
              render={({ field }) => (
                <TextField
                  type="number"
                  placeholder="Max Value"
                  size="small"
                  sx={{ width: '100%' }}
                  max={condition?.Type.Maximum}
                  min={condition?.Type.Minimum}
                  step={condition?.Type.Step}
                  {...field}
                />
              )}
            />
          </Box>
        </>
      );
    } else {
      return (
        <Controller
          name={`${type.name}.${index}.value`}
          control={control}
          rules={{ required: 'Value is required' }}
          render={({ field }) => (
            <>
              <InputLabel id="value">Value</InputLabel>
              <TextField
                type="number"
                placeholder="Type a Value"
                size="small"
                sx={{ width: '100%' }}
                max={condition?.Type.Maximum}
                min={condition?.Type.Minimum}
                step={condition?.Type.Step}
                {...field}
              ></TextField>
            </>
          )}
        />
      );
    }

  }

  const renderToggleType = (condition: any, index: number, type: IType) => (
    <>
      <InputLabel id="value">Value</InputLabel>
      <CheckboxElement
        name={`${type.name}.${index}.value`}
        control={control}
        size="small"
        // label="Value"
        required
        // fullWidth
        onChange={(value: any) => {
          console.log(value)
          setValue(`${type.name}.${index}.value`, (value.target.checked).toString())
        }}
      />
    </>
  );

  const renderEqualityOptions = (condition: any, index: number) => {
    console.log(condition)
    if (condition && condition?.TypeId && CFTypeIdDetail(condition?.TypeId).ClassBinding) {
      switch (CFTypeIdDetail(condition.TypeId).ClassBinding) {
        case 'cfTDropdown': return IcfTDropdownCasesArray;
        case 'cfTDate': return IcfTDateCasesArray;
        case 'cfTString': return IcfTStringCasesArray;
        case 'cfTInteger': return IcfTIntegerCasesArray;
        case 'cfTToggle': return IcfTToggleCasesArray;
        default: return []
      }
    }
  };

  const renderDynamicField = React.useCallback((selectedObject: any, index: number, type: IType) => {
    if (!selectedObject?.TypeId) return null;

    const binding = CFTypeIdDetail(selectedObject.TypeId).ClassBinding;
    const fieldMap = {
      'cfTDropdown': () => renderDropdownType(selectedObject, index, type),
      'cfTDate': () => renderDateType(selectedObject, index, type),
      'cfTString': () => renderStringType(selectedObject, index, type),
      'cfTInteger': () => renderIntegerType(selectedObject, index, type),
      'cfTToggle': () => renderToggleType(selectedObject, index, type)
    };

    // return fieldMap[binding]?.() ?? <div>default</div>;
    return fieldMap[binding as keyof typeof fieldMap]?.() ?? <div>default</div>;
  }, []);

  React.useEffect(() => {
    const subscription = watch((formValues) => {
      console.log('Form values changed:', formValues);

      // Handle form value changes here
      // For example, you could validate conditions, update derived values, etc.
    });

    // Cleanup subscription on unmount
    return () => subscription.unsubscribe();
  }, [watch]);


  const ConditionRow = React.memo(({ key, item, index, type }: { key: number; item: NewCondition; index: number; type: IType }) => {
    const { watch, control } = useFormContext<WorkflowRule>();

    console.log(item)
    console.log(type)

    return (
      <Paper elevation={0} sx={{ p: 2, mb: 4, border: '1px solid', borderColor: 'divider', width: '90%' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid size={6}>
            <Controller
              key={key}
              name={`${type.name}.${index}.column`}
              control={control}
              rules={{ required: 'Condition is required' }}
              render={({ field }) => (
                <>
                  <InputLabel id="condition">Condition</InputLabel>
                  <Select
                    {...field}
                    size="small"
                    onChange={(e) => {
                      field.onChange(e); // default RHF onChange
                      handleConditionOnChange(item, index, e.target.value, type); // custom handler
                    }}
                    placeholder={"Select a Condition"}
                    style={{ width: '100%' }}
                    endAdornment={
                      (baseFields.isPending || customFieldsByCustomer.isPending) ? (
                        <CircularProgress
                          size={20}
                          sx={{
                            position: 'absolute',
                            right: 25,
                            color: 'grey.500'
                          }}
                        />
                      ) : null
                    }
                  >
                    <ListSubheader>Base Fields</ListSubheader>
                    {baseFields?.data && baseFields?.data.map((item2: any) => {
                      return (
                        <MenuItem value={item2.Meta.Name}>{item2.Meta.Name}</MenuItem>
                      )
                    })}
                    <ListSubheader>Custom Fields</ListSubheader>
                    {customFieldsByCustomer?.data && customFieldsByCustomer?.data.map((item2: any) => {
                      return (
                        <MenuItem value={item2.Meta.Name}>{item2.Meta.Name}</MenuItem>
                      )
                    })}
                  </Select>
                </>
              )}
            />
          </Grid>
          <Grid size={5}>
            {watch(`${type.name}.${index}.column`) && (
              <Controller
                name={`${type.name}.${index}.equalityDisplay`}
                control={control}
                rules={{ required: 'Equality is required' }}
                render={({ field }) => (
                  <>
                    <InputLabel id="condition">Equality</InputLabel>
                    <Select
                      {...field}
                      size="small"
                      onChange={(e) => {
                        field.onChange(e); // default RHF onChange
                        handleEqualityOnChange(item, index, e.target.value, type); // custom handler
                      }}
                      placeholder={"Equals..."}
                      style={{ width: '100%' }}
                    >
                      {renderEqualityOptions(watch(`${type.name}.${index}.conditionObj`), index)?.map((item: any) => {
                        return (
                          <MenuItem value={item.name}>{item.name}</MenuItem>
                        )
                      })}
                    </Select>
                  </>
                )}
              />
            )}

          </Grid>
          <Grid size={1}>
            <IconButton size="small" color="error" onClick={() => {
              if (type?.name === 'any_conditions') {
                anyConditionsRemove(index)
              } else {
                allConditionsRemove(index)
              }
            }}>
              <X size={20} />
            </IconButton>
          </Grid>
          <Grid size={12}>
            <Box sx={{ width: '100%' }}>

              {watch(`${type.name}.${index}.column`) !== "" && watch(`${type.name}.${index}.equality`) !== EqualityNumber.isSet && watch(`${type.name}.${index}.equality`) !== EqualityNumber.isNotSet && watch(`${type.name}.${index}.equality`) !== EqualityNumber.today && (
                renderDynamicField(watch(`${type.name}.${index}.conditionObj`), index, type)
              )}
            </Box>
          </Grid>

        </Grid>
      </Paper>
    )
  });

  return (
    <>
      {/* <Typography variant='button' color="text.primary" sx={{ mt: 4 }}>
        Choose Conditions
      </Typography>
      <Divider sx={{ mb: 6 }} /> */}
      <Grid container sx={{ overflow: 'auto', height: '100%' }}>

        <Grid size={{ xs: 12, md: 6 }}>

          {/* {match Any} */}
          <Box sx={{ height: '100%' }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Match Any Conditions
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Any conditions in this column must be true (OR)
              </Typography>
            </Box>

            <Box >
              {anyConditionsFields.map((item, index) => (
                <ConditionRow key={index} item={item} index={index} type={{ name: 'any_conditions' }} />
              ))}
            </Box>
            <Button
              id='add-condition-btn-any'
              variant="outlined"
              startIcon={<Plus size={20} />}
              onClick={handleAddAnyCondition}
              sx={{ mt: 2 }}
            >
              Add Match Any Condition
            </Button>
          </Box>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          {/* {match All} */}
          <Box sx={{ height: '100%' }}>
            <Box sx={{ mb: 3 }}>
              <Typography variant="h6" gutterBottom>
                Match All Conditions
              </Typography>
              <Typography variant="body2" color="text.secondary">
                All conditions in this column must be true (AND)
              </Typography>
            </Box>

            <Box >
              {allConditionsFields.map((item, index) => (
                <ConditionRow key={index} item={item} index={index} type={{ name: 'all_conditions' }} />
              ))}
            </Box>

            <Button
              id='add-condition-btn-all'
              variant="outlined"
              startIcon={<Plus size={20} />}
              sx={{ mt: 2 }}
              onClick={handleAddAllCondition}
            >
              Add Match All Condition
            </Button>
          </Box>
        </Grid>
      </Grid>
    </>
  )
}

export default WorkflowRuleStep2